function Condition({ when, children }) {
  return when ? children : null;
}

export default Condition;
